class FontAwesome {
  public static get ID() {
    return {
      CUSTOM: 8,
    }
  }
  public static get icon() {
    return {
      'fa-coffee': 'fa-coffee',
      'fa-cutlery': 'fa-utensils',
      'fa-bed': 'fa-bed',
      'fa-bath': 'fa-bath',
      'fa-car': 'fa-car',
      'fa-dropbox': 'fa-box',
      'fa-wrench': 'fa-wrench',
      'fa-plug': 'fa-plug',
      'fa-rocket': 'fa-rocket',
      'fa-television': 'fa-tv',
      'fa-binoculars': 'fa-binoculars',
      'fa-shopping-bag': 'fa-shopping-bag',
      'fa-futbol-o': 'fa-futbol',
      'fa-comments-o': 'fa-comments',
      'fa-calendar-check-o': 'fa-calendar-check',
      'fa-calendar-times-o': 'fa-calendar-times',
      'fa-check-square-o': 'fa-check-square',
      'fa-commenting-o': 'fa-commenting',
      'fa-check': 'fa-check',
      'fa-eye': 'fa-eye',
      'fa-tasks': 'fa-tasks',
      'fa-times': 'fa-times',
      'fa-at': 'fa-at',
    }
  }
}

export default FontAwesome
